import service from "@/utils/request"
/*登陆
username: 用户名
password: 密码
* */
const _login = (params)=>{
  return service.post('/auth/login',params);
};
/*
* 发送验证码
* */
const _getPhoneCode = (params)=>{
  return service.post('/sms/validate-code',params);
};
/*注册
username: 用户名
password: 密码
* */
const _register = (params)=>{
  return service.post('/auth/register',params);
};

/*获取用户数据
*
* */
const _getUserData = (params)=>{
  return service.post('/auth/me',params);
};
/*退出登录
* */
const _logout = (params)=>{
  return service.post('/auth/logout',params);
};
/*
* 获取报名列表
* */
const _getEventCustomers=(params)=>{
  return service({
    url: '/event-customers',
    method: 'get',
    params: params
  })
}
// 报名详情
const _getEventCustomersDetail= id=>{
  return service.get('/event-customers/'+id)
}
/*
* 产品详情
* */
const _getProductDetail = id=>{
  return service.get('/events/'+id);
}
/*
提交报名
* */
const _submitCustomer = params=>{
  return service.post('/event-customers',params);
}

/*
* 获取报名信息
* */
const _getCustomer = id=>{
  return service.get('/events/'+id+'/customer-keys');
}
/*
* 成为合作商
* */
const _submitCompanies=(params)=>{
  return service.post('/companies',params)
}
/*
* 注册主办方
* */
const _enterpriseCreate = (params) => {
  return service.post('/enterprises', params);
}
/*主办方发布的活动*/
const _getEnterprisesList = id=>{
  return service.get('/enterprises/'+id+'/events');
}
/*主办方发布的活动*/
const __notificationsList = ()=>{
  return service.get('/notifications');
}
/*主办方发布的活动*/
const __notificationsDetail = id=>{
  return service.get('/notifications/'+id);
}


/* 忘记密码
username: 用户名
password: 密码
* */
const _forgetPassword = (params)=>{
  return service.post('/auth/forget-password',params)
};
/*微信登录*/
const _wxLogin = (code)=>{
  return service.get('/wechat/login?code='+code);
}

/*
banner
* */
const _getBanners = ()=>{
  return service.get('/banners');
}
/*
修改用户资料
* */
const _updateData = (params)=>{
  return service.put('/profile',params);
}
/*
获取图片临时地址Base64
* */
const _getImgUrlBase64= (params)=>{
  return service.post('/upload/base64',params);
}
/*
获取图片临时地址Base64
* */
const _bindMobile= (params)=>{
  return service.post('/auth/bind-mobile',params);
}
const _customerKeysAll = id=>{
  return service.get('/events/'+id+'/customer-keys-all');
}
// 获取消息未读列表
const _unreadNotifications = ()=>{
  return service.get('/unread-notifications');
}
// 读取未读消息
const _readMessage = (id)=>{
  return service.post(`/notifications/${id}/read`);
}


/*
* 微信分享
* /api/wechat/js
* */
const _wxConfig = (url)=>{
  return service.get('/wechat/js?url='+url);
}
//省市区
const _provinces = (url)=>{
    return service.get('/provinces');
}
// 新增活动
const _activities = (params)=>{
    return service.post('/activities',params);
}
// 新增供应商
const _suppliers = (params)=>{
    return service.post('/suppliers',params);
}

// 供应商类型
const _getSupplierType = ()=>{
    return service.get('/supplier-type');
}
export{
    _suppliers,
    _getSupplierType,
    _activities,
    _provinces,
  _readMessage,
  _unreadNotifications,
  _login,
  _register,
  _getUserData,
  _getBanners,
  _logout,
  _getPhoneCode,
  _getEventCustomers,
  _getProductDetail,
  _submitCustomer,
  _getCustomer,
  _submitCompanies,
  _getEventCustomersDetail,
  _enterpriseCreate,
  _getEnterprisesList,
  __notificationsList,
  __notificationsDetail,
  _forgetPassword,
  _bindMobile,
  _wxLogin,
  _updateData,
  _getImgUrlBase64,
  _wxConfig,
  _customerKeysAll,
}



// WEBPACK FOOTER //
// ./src/api/lib.js